<template>
  <div class="container">
    <div class="row">
      <div class="col-12 h1 b1 relative" align="center">
        {{ $t("prices-title1") }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 b2 h4 relative" align="center">
        {{ $t("prices-list") }}
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-11">
        <div class="row d-flex justify-content-center">
          <div class="col-12 col-md-12 col-lg-3">
            <v-card class="my-card">
              <div class="row">
                <div class="col-1 mx-auto mycard-logo" align="center">
                  <div class="green-circle">
                    <v-icon class="text-light">mdi-printer</v-icon>
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-center">
                <div class="col-12 b1" align="center">{{ $t("cost1") }}</div>
              </div>
              <div class="row px-7" align="center">
                <div class="col-12 text-small py-4">
                  <div class="row d-flex justify-content-center">
                    <div class="col-6 b1" align="right">
                      {{ $t("both-black-white") }}
                    </div>
                    <div class="col-6">
                      <v-chip small>{{ prices.BW2 }}</v-chip>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-small py-4">
                  <div class="row">
                    <div class="col-6 b1" align="right">
                      {{ $t("black-white") }}
                    </div>
                    <div class="col-6">
                      <v-chip small class="text-smaller">{{
                        prices.BW1
                      }}</v-chip>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-small py-4">
                  <div class="row">
                    <div class="col-6 b1" align="right">
                      {{ $t("both-colorfull") }}
                    </div>
                    <div class="col-6">
                      <v-chip small>{{ prices.RGB2 }}</v-chip>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-small py-4">
                  <div class="row">
                    <div class="col-6 b1" align="right">
                      {{ $t("colorfull") }}
                    </div>
                    <div class="col-6">
                      <v-chip small>{{ prices.RGB1 }}</v-chip>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
          <div class="col-12 col-md-12 col-lg-3">
            <v-card class="my-card">
              <div class="row">
                <div class="col-1 mx-auto mycard-logo" align="center">
                  <div class="green-circle">
                    <v-icon class="text-light">mdi-moped</v-icon>
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-center">
                <div class="col-12 b1" align="center">
                  {{ $t("deliver-cost1") }}
                </div>
                <div class="col-12 mt-n5" align="center">
                  <v-chip small>{{ prices.tehran }}</v-chip>
                </div>
              </div>
              <br />
              <br />
              <div class="row d-flex justify-content-center">
                <div class="col-12 b1" align="center">
                  {{ $t("deliver-cost2") }}
                </div>
                <div class="col-12 b1 mt-n5" align="center">
                  <v-chip small>{{ prices.shehrestan }}</v-chip>
                </div>
              </div></v-card
            >
          </div>
          <div class="col-12 col-md-12 col-lg-3">
            <v-card class="my-card">
              <div class="row">
                <div class="col-1 mx-auto mycard-logo" align="center">
                  <div class="green-circle">
                    <v-icon class="text-light">mdi-notebook</v-icon>
                  </div>
                </div>
              </div>
              <div class="row d-flex justify-content-center" align="center">
                <div class="col-12 b1" align="center">
                  {{ $t("cost3") }}
                </div>

                <div class="col-6 mt-n7">
                  <div class="row px-4">
                    <div class="col-12 text-small b1">{{ $t("less100") }}</div>
                    <div class="col-12 text-small mb-2">
                      <v-chip small class="mt-n2">{{ prices.S100 }}</v-chip>
                    </div>
                    <div class="col-12 text-small b1">{{ $t("200-250") }}</div>
                    <div class="col-12 text-small mb-2">
                      <v-chip small class="mt-n2">{{ prices.S250 }}</v-chip>
                    </div>
                  </div>
                </div>
                <div class="col-6 px-4 mt-n7">
                  <div class="row">
                    <div class="col-12 text-small b1">{{ $t("100-200") }}</div>
                    <div class="col-12 text-small b1 mb-2">
                      <v-chip small class="mt-n2">{{ prices.S200 }}</v-chip>
                    </div>
                    <div class="col-12 text-small b1">{{ $t("250-300") }}</div>
                    <div class="col-12 text-small mb-2">
                      <v-chip small class="mt-n2">{{ prices.S300 }}</v-chip>
                    </div>
                  </div>
                </div>
                <div class="col-12 text-small b1">{{ $t("300-350") }}</div>
                <div class="col-12 text-small mb-2">
                  <v-chip small class="mt-n2">{{ prices.S350 }}</v-chip>
                </div>
                <hr class="w-75" />
                <div class="col-12 text-small b1 mt-n5">{{ $t("punch") }}</div>
                <div class="col-12 text-small mb-2">
                  <v-chip small class="mt-n2">{{ prices.M }}</v-chip>
                </div>
              </div></v-card
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "landing",
  data() {
    return {
      prices: {
        BW1: "",
        BW2: "",
        M: "",
        RGB1: "",
        RGB2: "",
        S100: "",
        S200: "",
        S250: "",
        S300: "",
        S350: "",
        shehrestan: "",
        tehran: "",
      },
    };
  },
  mounted() {
    this.axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$session.get("token");
    this.axios.get("getbaseprice").then((response) => {
      console.log(response.data.BW1);
      this.prices.BW1 = response.data.BW1 +  this.$t('toman');
      this.prices.BW2 = response.data.BW2 +  this.$t('toman');
      this.prices.M = response.data.M +  this.$t('toman');
      this.prices.RGB1 = response.data.RGB1 +  this.$t('toman');
      this.prices.RGB2 = response.data.RGB2 +  this.$t('toman');
      this.prices.S100 = response.data.S100 +  this.$t('toman');
      this.prices.S200 = response.data.S200 +  this.$t('toman');
      this.prices.S250 = response.data.S250 +  this.$t('toman');
      this.prices.S300 = response.data.S300 +  this.$t('toman');
      this.prices.S350 = response.data.S350 +  this.$t('toman');
      this.prices.shehrestan = response.data.shehrestan +  this.$t('toman');
      this.prices.tehran = response.data.tehran +  this.$t('toman');
    });
  },
};
</script>
<style scoped>
.mycard-logo {
  width: 100px;
}
.my-card {
  height: 347px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.25) !important;
}
</style>
